import { Injectable } from '@angular/core';
import { HomeFlexApiResponseModel } from '@core/models/DTOs/home-page-flex.dto';
import { HomeFlexModel, HomeModel } from '@models/home-page-flex';
import { Observable, forkJoin } from 'rxjs';
import { map, switchMap, tap } from 'rxjs/operators';
import { BaseRepository } from './base.repository';

@Injectable()
export class HotelRepository extends BaseRepository {
 getAllSectionsData(accommodation: string, refresh = false): Observable<HomeModel> {
  const url =
   this.baseUrl +
   (accommodation == 'hotel' ? 'v1/home/GetAllSections/1' :
          accommodation == 'special' ? 'v1/home/GetAllSections/5' : 'v1/accomodation/GetAllSections');
  return this.get<HomeFlexApiResponseModel>(url).pipe(
   map((res) => {
       const { Sections, AccomodationList, Statistics, SupportPhone, SuggestedTypes } = res;
       return { Sections, AccomodationList, Statistics, SupportPhone, SuggestedTypes };
   })
  );
 }

 getSectionById(sectionQuery: string, refresh = false) {
  const url = this.baseUrl + `v1/accomodation/GetAccomodations/?${sectionQuery}`;
  return this.get<any>(url, refresh);
 }

 // A method that returns an object stream with the template type and the response as keys
 getSectionsData(refresh = false): Observable<any> {
  interface ApiResponse extends HomeFlexModel {
   TemplateType: number;
  }
  const url = this.baseUrl + 'home/GetAllSections';

  return this.get<HomeFlexModel[]>(url, refresh).pipe(
   switchMap((sections) => {
    return forkJoin(
     sections.map((section) => {
      return this.get(`${this.baseUrl}home/GetSection/${section.Id}`);
     })
    );
   })
  );
 }

 getSectionChainHotels() {
  const url = this.baseUrl + `home/GetChainHotels`;
  return this.get<any>(url);
 }

 


}
